import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Button, Think} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startThinking,
                'children': '开始思考'
            }),
            _$cc(Button, {
                'ev-click': this.stopThinking,
                'children': '停止思考'
            })
        ], 4, 'think-demo-loading-actions'),
        _$cc(Think, {
            'loading': this.get('loading'),
            'blink': this.get('loading'),
            'title': this.get('loading') ? '思考中...' : '已思考（用时 5 秒）',
            'content': this.get('content')
        })
    ], 4, 'think-demo-loading');
};